import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DragHandle from './drag-handle-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DragHandle {...validProps} />;
}
SvgComponent.iconName = 'drag-handle';

/**
 * @deprecated This is a legacy icon
 */
export const DragHandleIcon = svgIconWrapper(SvgComponent);
